<template>
  <div class="select" v-if="isOpen">
    <ul class="select__options select-options">
      <li
          class="select-options__item"
          v-for="(option, i) in options"
          :key="i"
          @click="handleClick(option)"
      >
        {{ option.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import CaretBottomSvg from '../../../../../assets/img/icons/caret-bottom.svg';

export default {
  name: 'customSelect',
  components: {
    CaretBottomSvg,
  },
  props: {
    options: Array,
    isOpen: Boolean,
  },
  data() {
    return {
      selected: null,
    };
  },
  methods: {
    handleClick(option) {
      this.selected = option;
      this.$emit('input', option);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.select {
  position: absolute;
  top: calc(100% + 7.25px);
  left: 0;
  z-index: 10;
  padding: 18px 15px 12px 0;
  width: 100%;
  height: fit-content;
  max-height: 240px;
  line-height: 20px;
  background-color: $c-white;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.095389);

  @include up-desktop {
    padding: 28px 15px 22px 0;
    height: fit-content;
    max-height: 277px;
  }

  &__options {
    padding: 0 20px;
    max-height: 210px;
    overflow-y: auto;

    @include up-tablet {
      padding: 0 30px;
    }

    @include up-desktop {
      max-height: 227px;
    }

    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
      background-color: rgba($c-scroll-gray, 0.3);
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 0;
      background-color: $c-scroll-gold;
    }
  }

  .select-options {
    &__item {
      cursor: pointer;

      &:not(:last-child) {
        margin-bottom: 1.2em;

        @include up-desktop {
          margin-bottom: 1.5em;
        }
      }
    }
  }
}
</style>
